export default "__VITE_ASSET__ZmaxD0gk__"